import type { CommentInterface } from 'modules/comments/components/comment/comment.types'
import type { PostStatusEnum } from 'modules/community/enums/post-status-enum'
import type { MentionInterface } from '../components/editor/elements/mention/mention.types'
import type { MemberWorkspaceRoleEnum } from '../enums/member-enum'
import type { PostAttachmentType } from './post-attachment'
import type { PostPinnedToType } from './post-pinned-to-type'

export interface PostAuthorInterface {
  workspaceRole?: MemberWorkspaceRoleEnum
  displayName: string
  avatarUrl: string
}

export interface PostInterface {
  id: number
  title: string
  createdAt: string
  content: string
  topic: {
    id: number
    path: string
    name: string
  }
  status: PostStatusEnum
  path: string
  userId: number
  isLiked: boolean
  likesCount: number
  author?: PostAuthorInterface
  mentions: MentionInterface[]
  commentsCount?: number
  attachments?: PostAttachmentType[]
  pinnedTo: PostPinnedToType[]
  scheduledTo: string | null
  publishedAt: string | null
  underModeration?: boolean
}

export interface PinPostInterface {
  source: 'community' | 'topic'
}

export interface CountPostInterface {
  count?: number
}

export interface PostCommentsCountInterface extends Record<number, number> {}

export interface ApiSearchPaginationResponseInterface<T> {
  items: T[]
  scroll: string | null
}

export interface CommentsSearchInterface extends CommentInterface {
  highlight: { comment: string; author?: string }
}

export interface SearchPostInterface extends PostInterface {
  highlight: {
    title?: string
    content?: string
    author?: string
  }
  comments: CommentsSearchInterface[]
}

export const isSearchPostGuard = (
  post: PostInterface | SearchPostInterface,
): post is SearchPostInterface => {
  return 'highlight' in post && post.highlight !== null
}
